// https://fontawesome.com/search
import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {library} from '@fortawesome/fontawesome-svg-core';
import {
  faInfo,
  faInbox,
  faAlignJustify,
  faFilePdf,
  faFolderOpen,
  faFileAlt,
  faFile,
  faFileArchive,
  faFileExcel,
  faSitemap,
  faTimes,
  faCheck,
  faArrowRight,
  faThLarge,
  faTasks,
  faStar,
  faPrint,
  faUsers,
  faEnvelope,
  faWrench,
  faChartBar,
  faExchangeAlt,
  faUser,
  faSignOutAlt,
  faTachometerAlt,
  faTable,
  faQuestion,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faInfo,
  faInbox,
  faAlignJustify,
  faFilePdf,
  faFolderOpen,
  faFileAlt,
  faFile,
  faFileArchive,
  faFileExcel,
  faSitemap,
  faTimes,
  faCheck,
  faArrowRight,
  faThLarge,
  faTasks,
  faStar,
  faPrint,
  faUsers,
  faEnvelope,
  faWrench,
  faChartBar,
  faExchangeAlt,
  faUser,
  faSignOutAlt,
  faTachometerAlt,
  faTable,
  faQuestion
);

const Icon = ({icon, ...rest}) => <FontAwesomeIcon icon={icon} {...rest} />;

export default Icon;
